var React = require('react');

function MailIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#ffffff","d":"m154 134.4c-6.6055 0-12.668 1.9844-17.852 5.25l198.8 168.18c9.1016 7.707 21.367 7.707 30.449 0l198.45-168.18c-5.1836-3.2656-11.246-5.25-17.852-5.25h-392zm-31.676 22.574c-1.1992 3.457-1.9258 7.1445-1.9258 11.023v224c0 6.7461 2.0273 12.945 5.4258 18.199l142.28-129.67zm455.35 0-145.43 123.38 141.93 129.85c3.3984-5.2539 5.4258-11.453 5.4258-18.199v-224c0-3.8789-0.72656-7.5664-1.9258-11.023zm-162.57 138.07-35.352 29.926c-17.098 14.504-42.227 14.484-59.324 0l-35.176-29.75-141.23 128.8c3.1602 0.97656 6.4844 1.5742 9.9766 1.5742h392c3.4883 0 6.8164-0.59766 9.9766-1.5742l-140.87-128.98z"}));
}

MailIcon.defaultProps = {"version":"1.1","viewBox":"120.4 134.4 459.2 291.19"};

module.exports = MailIcon;

MailIcon.default = MailIcon;
